import { message, Popover } from "antd";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { constants } from "../../../constants/constants";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import {
  deleteMobilePage,
  getMobilePage,
  updatePosition,
  updateMobilePage,
} from "../../../utils/ApiCalls/AddMobilePage";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import YouTubeEmbed from "../../Banner/YouTubeEmbed";
import CustomHeaderTitle from "../../constants/CustomHeaderTitle";
import HeaderBread from "../../HeaderBread";
import Logs from "../../Logs";
import ActiveSwitchFile from "../../SwitchFile";
import CustomizedTable from "../../UI/CustomizedTable";
import { getActivityCategory } from "../../../utils/ApiCalls/Mobile/ActivityMasters";
import SwitchBar from "../../Pages/SwitchBar";
import SearchField from "../../SearchField";
import CustomizedDragNDrop from "../../UI/CustomizedDragNDrop";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";

export const CustomList = ({ category, type }) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState();
  const [count, setCount] = useState(0);
  const [active, setActive] = useState("listing");
  const [{ permission, userDetails }, dispatch] = useDataLayerValue();
  const [sort, setSort] = useState("position");
  const [vesselOptions, setVesselOptions] = useState([]);
  const [order, setOrder] = useState("DESC");
  const [columns, setColumns] = useState([]);
  const [navigation, setNavigation] = useState([]);
  const [cat, setgetCat] = useState();
  const [categoryOption, setactivitycategoryOption] = useState([]);

  const location = useLocation();
  const params = useParams();

  // const [activeCat, setActiveCat] = useState(null);
  // const [page, setPage] = useState(1);
  // const [pageSize, setPageSize] = useState(10);
  // const [search, setSearch] = useState("");
  const q = new URLSearchParams(window.location.search);

  const [page, setPage] = useState(() => parseInt(q.get("page")) || 1);
  const [pageSize, setPageSize] = useState(() => parseInt(q.get("pageSize")) || 10);
  const [search, setSearch] = useState(() => q.get("search") || "");
  const [activeCat, setActiveCat] = useState(() =>
    q.get("activeCat") ? Number(q.get("activeCat")) : null
  );


  const firstLoad = useRef(true);

  // Step 1 — Read URL params (only once)
  useEffect(() => {
    if (firstLoad.current) {
      const q = new URLSearchParams(location.search);
      setPage(parseInt(q.get("page")) || 1);
      setPageSize(parseInt(q.get("pageSize")) || 10);
      setSearch(q.get("search") || "");

      const activeCatParam = q.get("activeCat");
      if (activeCatParam) {
        setActiveCat(Number(activeCatParam));
      }

      firstLoad.current = false;
    }
  }, [location.search]);

  // Step 2 — Keep URL synced with current state
  useEffect(() => {
    if (firstLoad.current) return; // prevent running on first render

    const q = new URLSearchParams();
    q.set("page", page);
    q.set("pageSize", pageSize);
    if (search) q.set("search", search);
    if (activeCat) q.set("activeCat", activeCat);

    const current = new URLSearchParams(location.search);
    if (current.toString() !== q.toString()) {
      navigate({ search: q.toString() }, { replace: true });
    }
  }, [page, pageSize, search, activeCat]);

  // Reset pagination when user switches category tab
  const prevCatRef = useRef(null);
  useEffect(() => {
    if (!firstLoad.current && prevCatRef.current && prevCatRef.current !== activeCat) {
      setPage(1);

      const q = new URLSearchParams(location.search);
      q.set("page", 1);
      q.set("pageSize", pageSize);
      q.set("activeCat", activeCat);
      if (search) q.set("search", search);

      navigate({ search: q.toString() }, { replace: true });
    }

    prevCatRef.current = activeCat;
  }, [activeCat]);


  // Step 3 — Fetch category + vessels
  const getOptionLocation = async () => {
    dispatch({ type: "SET_LOADING", loading: true });

    let vessels = await getVessels();
    let res = await getActivityCategory({
      parent_category: category?.id,
      is_active: 1,
      limit: 10000,
    });

    if (vessels.error) {
      Swal.fire({ icon: "error", title: "Oops...", text: vessels.error });
    } else {
      setVesselOptions(vessels);
      setactivitycategoryOption(res?.data || []);

      // Step 4 — On first load, if no activeCat in URL, set first one
      const q = new URLSearchParams(location.search);
      const urlActiveCat = q.get("activeCat");

      if (!urlActiveCat && res?.data?.length) {
        const firstId = res.data[0].id;
        setActiveCat(firstId);

        q.set("activeCat", firstId);
        q.set("page", page);
        q.set("pageSize", pageSize);
        if (search) q.set("search", search);

        navigate({ search: q.toString() }, { replace: true });
      }
    }

    dispatch({ type: "SET_LOADING", loading: false });
  };

  // Step 5 — Trigger data fetch when category changes
  useEffect(() => {
    if (category?.id) getOptionLocation();
  }, [category]);

  useEffect(() => {
    if (category?.id)
      setNavigation([
        {
          title: "Home",
          route: "/",
        },
        {
          title: "Mobile App Shore CMS",
          route: "/",
        },
        {
          title: "All Pages",
          route:
            "/shore/all-pages/" +
            vesselOptions
              .find((item) => item.id == category?.vessel_id)
              ?.name?.replaceAll(" ", "-")
              ?.toLowerCase() +
            "/" +
            +category.id,
        },
        {
          title: vesselOptions.find((item) => item.id == category?.vessel_id)
            ?.name,
          route:
            "/shore/all-pages/" +
            vesselOptions
              .find((item) => item.id == category?.vessel_id)
              ?.name?.replaceAll(" ", "-")
              ?.toLowerCase() +
            "/" +
            +category.id,
        },
        {
          title: category?.name,
          route:
            "/shore/all-pages/" +
            vesselOptions
              .find((item) => item.id == category?.vessel_id)
              ?.name?.replaceAll(" ", "-")
              ?.toLowerCase() +
            "/" +
            +category.id,
        },
      ]);
  }, [vesselOptions, category]);

  const sortHandler = async (options) => {
    if (Object.keys(options).length > 0) {
      let sort, order;
      sort = options.columnKey;
      order =
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
            ? "desc"
            : undefined;
      setSort(sort);
      setOrder(order);
      await getData(page, sort, order);
    }
  };

  const handleDelete = async (id, title,record) => {
    if (true || checkPermission(permission, "delete_per", "ships", window?.location?.pathname)) {
      await deleteMobilePage(id);
      // await deleteMenuList({ url });
      addlog(
       LOG_ACTIONS.REMOVED, 
        category?.name + category?.vessel_id,
        { id,title: `${record?.venue?.name || title}, ${record?.category?.name} Page` },
        userDetails.id
      );
      getData(page, sort, order);
    } else {
      message.error("Missing Permission for delete ");
    }
  };

  const handleUpdate = async (id, values, title, location_id,record) => {
    if (true || checkPermission(permission, "update_per", "Categories", window?.location?.pathname)) {
      let data = await updateMobilePage(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          values.is_active === 1 ? LOG_ACTIONS.ACTIVATED : LOG_ACTIONS.DEACTIVATED,
          category?.name + category?.vessel_id,
          {
            ...values,
            id,
            title: `${record?.venue?.name || title}, ${record?.category?.name} Page`,
            location_id:location_id || null
          },
          userDetails.id
        );
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };

  const setPositionalValue = (data) => { };

  const updateBannerPosition = async (banners) => {
    if (true || checkPermission(permission, "update_per", "Banner", window?.location?.pathname)) {
      try {
        let args = {
          catergory_id: category?.id,
          search: search,
          page: page,
          limit: pageSize,
          sort,
          order,
        };

        if (activeCat !== "all") {
          args.child_category_id = activeCat;
        }

        const data = await updatePosition(banners, args);
        addlog(
          LOG_ACTIONS.UPDATED,
          category?.name + category?.vessel_id,
          {
            id: banners[0]?.id, title: category?.name + " Position Updated",
           },
          userDetails.id
        );
        if (data.error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.error,
          });
        } else if (data.data) {
          setRows(data.data);
          setCount(data.count);
          setPositionalValue(data.data);
        }
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } catch (error) {
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message || "Unknown error occurred",
        });
      }
    } else {
      message.error("Update permission missing");
    }
  };

  useEffect(() => {
    setColumns([
      {
        title: "No",
        width: 10,
        dataIndex: "id",
        key: "position",
        fixed: "left",
        render: (position, record, index) => (page - 1) * pageSize + index + 1,
      },
      {
        title: "Title/Venue",
        width: 10,
        dataIndex: "Title",
        key: "title",
        fixed: "left",
        render: (item, record) => (
          <render>{item || record?.venue?.name}</render>
        ),
      },
      {
        title: "Parent Category",
        width: 10,
        dataIndex: "slug",
        key: "slug",
        fixed: "left",
        render: (item, record) => <render>{category?.name}</render>,
      },
      {
        title: "Sub Category",
        width: 10,
        dataIndex: "slug",
        key: "slug",
        fixed: "left",
        render: (item, record) => (
          <render>{record?.child_category?.name}</render>
        ),
      },
      {
        title: "Image",
        width: 30,
        dataIndex: "image",
        key: "image",
        render: (image, record) => {
          if (record.content_type === "video") {
            return (
              <video
                src={`${constants.MEDIAURL}/${image}`}
                style={{ width: "100px", height: "80px" }}
              >
                <track kind="captions" src="" label="English captions" />
              </video>
            );
          } else if (record.content_type === "link") {
            return (
              <YouTubeEmbed
                videoUrl={`${constants.MEDIAURL}/${image}`}
                width="100px"
                height="80px"
              />
            );
          } else {
            return (
              <img
                alt="banner"
                src={`${constants.MEDIAURL}/${image}`}
                style={{ width: "100px", height: "80px" }}
              />
            );
          }
        },
      },
      {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        width: 30,
        sorter: (a, b) => "",
        render: (item, record, index) => (
          <ActiveSwitchFile
            item={item}
            record={record}
            index={index}
            handleUpdate={handleUpdate}
          />
        ),
      },
      {
        title: "Action",
        key: "operation",
        width: 30,
        render: (text, record) => (
          <div className="table_action_btn">
            <div
              onClick={() => {
                const vesselSlug = vesselOptions
                  .find((item) => item.id == category?.vessel_id)
                  ?.name?.replaceAll(" ", "-")
                  ?.toLowerCase();

                navigate(
                  `/shore/all-pages/${vesselSlug}/${category.id}/edit/${record.id}${location.search}`
                );
              }}

              className="btn"
            >
              <i
                className="ri-edit-2-line"
                data-toggle="tooltip"
                title="Edit"
              ></i>
            </div>
            <DeletePop
              onConfirm={() =>
                handleDelete(record.id, record?.title || record?.venue?.name,record)
              }
            >
              <div>
                {" "}
                <button className="btn delete_btn">
                  <i
                    className="ri-delete-bin-line"
                    data-toggle="tooltip"
                    title="Delete"
                  ></i>
                </button>
              </div>
            </DeletePop>
          </div>
        ),
      },
    ]);
  }, [page, pageSize, search, category, sort, order, vesselOptions]);

  const getData = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let dataQuery = {
      catergory_id: category?.id,
      search: search,
      page: page,
      limit: pageSize,
      sort,
      order,
    };
    if (activeCat !== "all") {
      dataQuery.child_category_id = activeCat;
    }
    let data = await getMobilePage(dataQuery);
    setRows(data.data);
    setCount(data?.count);

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  useEffect(() => {
    if (category?.id && activeCat) getData();
  }, [category, page, pageSize, search, category, activeCat, sort, order]);

  return (
    <Layout type={"read_per"} module_data={"ships"}>
      <CustomHeaderTitle title={"Deals"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={category?.name}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Pages List", value: "listing" },
                { value: "logs", title: " History Logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">All {category?.name} List</h5>
                  {!categoryOption?.length > 0 ? (
                    <Popover
                      placement="topLeft"
                      title={<span>No Child Categories Found</span>}
                      content={
                        <div>
                          <p>Please Add Child Categories</p>
                        </div>
                      }
                    >
                      <div className="btn add_v_btn">Add New Page</div>
                    </Popover>
                  ) : (
                    <Link
                      to={
                        "/shore/all-pages/" +
                        vesselOptions
                          .find((item) => item.id == category?.vessel_id)
                          ?.name?.replaceAll(" ", "-")
                          ?.toLowerCase() +
                        "/" +
                        category.id +
                        "/add" +
                        location.search
                      }
                      className="btn add_v_btn"
                    >
                      Add New Page
                    </Link>

                  )}
                </div>

                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "space-between",
                      }}
                    >
                      <SwitchBar
                        tabs={
                          [
                            ...categoryOption?.map((item) => ({
                              title: item.name,
                              value: item.id,
                            })),
                          ] || []
                        }
                        activeTab={activeCat}
                        setActiveTab={setActiveCat}
                      />
                      <div style={{ maxWidth: 200 }}>
                        <SearchField
                          value={search}
                          SearchValue={() => {
                            setPage(page);
                          }}
                          setValue={(e) => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    ></div>
                    {rows && (
                      <CustomizedDragNDrop
                        setRows={setRows}
                        setPageSize={setPageSize}
                        setPage={setPage}
                        pageSize={pageSize}
                        page={page}
                        count={count}
                        columns={columns}
                        rows={rows}
                        title={"Cabin Category"}
                        sortHandler={sortHandler}
                        updatePosition={updateBannerPosition}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>{" "}
        {active === "logs" && category?.name && (
          <Logs
            type={category?.name + category?.vessel_id}
            slug={
              "/shore/all-pages/" +
              vesselOptions
                .find((item) => item.id == category?.vessel_id)
                ?.name?.replaceAll(" ", "-")
                ?.toLowerCase() +
              "/" +
              +category.id +
              "/edit/"
            }
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};
